const jQ = jQuery.noConflict();

class EqualCols {
    constructor(args) {
        this.selector = args.sel;
        this.wrapper = args.wrap;
        this.items = args.items;
        this.itemsMobile = args.itemsMobile;
        this.itemsTablet = args.itemsTablet;
    }
    init() {
        const items = this.items;
        const mob = this.itemsMobile;
        const tab = this.itemsTablet;
        if (jQ( this.wrapper ).length ) {
            jQ( this.selector ).evenColumns({
                columns: items,
            }, {
                maxScreenWidth: 991,
                columns: tab,
            }, {
                maxScreenWidth: 767,
                columns: mob,
            })
        }
    }
}

const archiveArgs = {
    sel: '.offcategory-grid > div',
    wrap: '.category-grid',
    items: 3,
    itemsTablet: 2,
    itemsMobile: 2,
};
const archiveProductCols = new EqualCols(archiveArgs);


function archiveCols (){
    const wrapper = jQ('.category-grid');

    wrapper.each(function(){

        const child = jQ(this).children('.product');
        jQ( child ).evenColumns({
            columns: 3,
        }, {
            maxScreenWidth: 991,
            columns: 2,
        }, {
            maxScreenWidth: 767,
            columns: 2,
        })
    });

}
export { archiveProductCols };
export { archiveCols };
